import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../constants";
import fetcher from "./fetcher";

const requestUpdateUser = (
    url: string,
    {
        arg,
    }: {
        arg: {
            languageCode?: string;
            username?: string;
            removeFromCompanyIds?: string[];
        };
    }
) =>
    fetcher(url, {
        options: {
            method: API_REST_METHODS.POST,
            body: JSON.stringify(arg),
        },
    });

export const useUpdateCurrentUser = ({
    onSuccess,
    onError,
}: {
    onSuccess?: () => void;
    onError?: (err: any, key: string) => void;
} = {}) => {
    const {
        trigger: triggerUpdateCurrentUser,
        isMutating: isLoadingUpdateCurrentUser,
    } = useSWRMutation(
        "/api/permission-management/v1/users/me",
        requestUpdateUser,
        {
            onSuccess,
            onError,
        }
    );

    return {
        triggerUpdateCurrentUser,
        isLoadingUpdateCurrentUser,
    };
};
